import { Modal, Form, Input } from 'antd';
import { FormEvent, useCallback } from 'react';

interface AdminNoteModalProps {
  note?: string;
  open?: boolean;
  onCancel: () => void;
  onSubmit: (values: any) => void;
}
export default function AdminNoteModal(
  {
    note = undefined,
    open = false,
    onCancel,
    onSubmit,
  } : AdminNoteModalProps,
) {
  const [form] = Form.useForm();
  const preventEnterDefaultBehavior = useCallback(
    (event: FormEvent<HTMLTextAreaElement>) => event.preventDefault(),
    [],
  );
  const onOk = useCallback(
    () => {
      form
        .validateFields()
        .then((values) => onSubmit(values));
    },
    [form, onSubmit],
  );

  return (
    <Modal
      open={open}
      title='URL Doxy'
      okText='Sauvegarder'
      cancelText='Annuler'
      onCancel={onCancel}
      width='768px'
      onOk={onOk}
    >
      <Form
        form={form}
        layout='vertical'
        initialValues={{ note }}
      >
        <Form.Item
          name='note'
          rules={[{ required: true }]}
        >
          <Input.TextArea
            name='note'
            rows={5}
            cols={32}
            onPressEnter={preventEnterDefaultBehavior}
            maxLength={512}
            showCount
          />
        </Form.Item>
      </Form>
    </Modal>
  );
}
